import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

import { OrderProductionStatus } from '../../sdk/order-production/order-production.types'

export const StyledStatusTag = styled(Box)<{ status: OrderProductionStatus }>`
  padding: 2px 8px;
  border-radius: 16px;
  align-items: center;

  ${({ status, theme }) => {
    switch (status) {
      case 'pending':
        return `
            background-color: ${getThemeColor('warning', theme)}22;
            color: ${getThemeColor('warning', theme)};
            border: 1px solid ${getThemeColor('warning', theme)};
        `
      case 'complete':
        return `
            background-color: ${getThemeColor('success', theme)}22;
            color: ${getThemeColor('success', theme)};
            border: 1px solid ${getThemeColor('success', theme)};
        `
    }
  }}
`
